// extracted by mini-css-extract-plugin
export default {"wrap":"GetFileBtn_wrap__ssSIY","disabled":"GetFileBtn_disabled__grNUE"};